import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=efb79d28&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"
import style0 from "./gallery.vue?vue&type=style&index=0&id=efb79d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb79d28",
  null
  
)

export default component.exports